import useToast from '@hooks/ui/useToast';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface Params {
    message: string;
}

declare module '@stackflow/config' {
    interface Register {
        IdentifyFailActivity: Params;
    }
}

const IdentifyFailActivity: ActivityComponentType<'IdentifyFailActivity'> = ({ params }) => {
    const { message } = params;
    const toast = useToast();
    const { replace } = useFlow();
    const { t } = useTranslation('common');
    useEffect(() => {
        toast.error(message || t('identifyFailed2'));
        replace('MainActivity', {}, { animate: false });
    }, [message, t]);
    return (
        <AppScreen>
            <div></div>
        </AppScreen>
    );
};

export default IdentifyFailActivity;
